export interface NativeFrameRef {
  current: number | null
}

export function drainScheduledNativeFrame(
  frame: NativeFrameRef,
  turnId: string,
  cancelFrame: (handle: number) => void,
  commitPending: (turnId: string) => void,
): boolean {
  const handle = frame.current
  if (handle === null) return false
  cancelFrame(handle)
  frame.current = null
  commitPending(turnId)
  return true
}

export function settleScheduledNativeFrameBeforeFailure(
  frame: NativeFrameRef,
  turnId: string,
  cancelFrame: (handle: number) => void,
  commitPending: (turnId: string) => void,
  surfaceFailure: () => void,
): boolean {
  const drained = drainScheduledNativeFrame(frame, turnId, cancelFrame, commitPending)
  surfaceFailure()
  return drained
}
